<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex sm3 pr-1>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 pr-1>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 pr-1>
            <v-text-field
              name="issueNo"
              label="Issue No"
              type="text"
              v-model="queryParams.issueNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="typeList"
              label="Type"
              v-model="queryParams.type"
              item-text="label"
              item-value="value"
              menu-props="auto"
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <v-data-table
            :headers="queryParams.type == 'EMR' ? emrHeaders : saleHeaders"
            :items="issueNoList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template
              slot="items"
              slot-scope="props"
              v-if="queryParams.type == 'EMR'"
            >
              <td @click="setEMR(props.item)">
                <a>{{ props.item.issueNo }}</a>
              </td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.status }}</td>
            </template>
            <template slot="items" slot-scope="props" v-else>
              <td
                @click="
                  setWholeSale(props.item.id),
                    (showWholeSaleListDialog = !showWholeSaleListDialog)
                "
              >
                <a>{{ props.item.issueNo }}</a>
              </td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.customer.code }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.regionName }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.priceModelName }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.netAmount }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
  
  <script>
import { emrService } from "../../services/emr-service";
import { wholeSaleService } from "../../services/whole-sale-service";
import { commonService } from "../../services/common-service";
import { StockIssueItem } from "../../models/model";

export default {
  name: "WholeSaleEMRDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerCode: "",
      issueNo: "",
      type: "WHOLE_SALE",
      status: "FINISHED",
      warehouseId: "",
      orderWarehouseId: "",
      isAddDetails: false,
      isAddUnits: false,
      checkLocationMovement: true,
      isOrderWholeSale: true,
      isStockIssue: false,
    },
    emrHeaders: [
      { text: "Issue No", align: "left", value: "issueNo", sortable: false },
      {
        text: "Issue Date",
        align: "left",
        value: "issueDate",
        sortable: false,
      },
      { text: "Description", value: "description", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    saleHeaders: [
      { text: "Issue No", align: "left", value: "issueNo", sortable: false },
      {
        text: "Issue Date",
        align: "left",
        value: "issueDate",
        sortable: false,
      },
      { text: "Customer Name", value: "customer.name", sortable: false },
      { text: "Customer Code", value: "customer.code", sortable: false },
      { text: "Shop", value: "shop.name", sortable: false },
      { text: "Region", value: "region.name", sortable: false },
      { text: "Currency", value: "currency.name", sortable: false },
      { text: "Price Model", value: "priceModel.name", sortable: false },
      { text: "Description", value: "description", sortable: false },
      { text: "Net Amount", value: "netAmount", sortable: false },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    typeList: [
      { label: "WHOLE_SALE", value: "WHOLE_SALE" },
      { label: "EMR", value: "EMR" },
    ],
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    issueNoList: [],
    stockIssueDetailList: [],
    warehouseId: "",
  }),
  watch: {
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = {
            ...this.params,
          };
          this.warehouseId = this.queryParams.warehouseId;
          this.issueNoList = [];
          this.stockIssueDetailList = [];
          this.getWholeSaleList();
        }
      },
    },
  },
  methods: {
    onSearch() {
      this.issueNoList = [];
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      if (this.queryParams.type == "WHOLE_SALE") {
        this.getWholeSaleList();
      } else if (this.queryParams.type == "EMR") {
        this.getEMRList();
      }
    },
    getWholeSaleList() {
      this.showListLoading = true;
      this.queryParams.status = "FINISHED";
      this.queryParams.warehouseId = "";
      this.queryParams.orderWarehouseId = this.warehouseId;
      this.queryParams.isOrderWholeSale = true;
      this.queryParams.isStockIssue = false;
      this.queryParams.isAddDetails = "";
      this.queryParams.isAddUnits = "";
      this.queryParams.checkLocationMovement = "";

      let order = this.pagination.descending ? "desc" : "asc";
      wholeSaleService
        .getWholeSaleList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.issueNoList = res.data.wholeSaleHeaderList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getEMRList() {
      if (this.queryParams.type == "EMR" || this.queryParams.type == "RMR") {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";
        this.queryParams.status = "CONFIRM";
        this.queryParams.orderWarehouseId = "";
        this.queryParams.warehouseId = this.warehouseId;
        this.queryParams.isOrderWholeSale = "";
        this.queryParams.isStockIssue = "";
        this.queryParams.isAddDetails = false;
        this.queryParams.isAddUnits = false;
        this.queryParams.checkLocationMovement = true;
        emrService
          .getEMRList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.issueNoList = res.data.emrList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    getWholeSale(id) {
      wholeSaleService
        .getWholeSaleDetail(id)
        .then((res) => {
          if (res.data) {
            this.setWholeSale(res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setWholeSale(wholeSale) {
      this.stockIssueDetailList = [];
      if (wholeSale) {
        wholeSale.wholeSaleDetails.forEach((element) => {
          let stockIssueItem = new StockIssueItem();
          stockIssueItem.productCode = element.productCode;
          stockIssueItem.productName = element.productName;
          stockIssueItem.factorUnitName = element.productUnit.factorUnitName;
          stockIssueItem.productUnits = [element.productUnit];
          stockIssueItem.qty = element.qty;
          stockIssueItem.binId = "";
          this.stockIssueDetailList.push(stockIssueItem);
        });
        this.dialogClose({
          issueNo: wholeSale.issueNo,
          isWholeSaleIssueNo: true,
          stockIssueDetailList: this.stockIssueDetailList,
        });
      } else {
        this.dialogClose({});
      }
    },
    setEMR(emr) {
      this.stockIssueDetailList = [];
      if (emr) {
        emr.emrDetailList.forEach((item) => {
          let stockIssueItem = new StockIssueItem();
          stockIssueItem.productId = item.productId;
          stockIssueItem.productCode = item.productCode;
          stockIssueItem.productName = item.productName;
          stockIssueItem.productUnitId = item.productUnitId;
          stockIssueItem.factorUnitName = item.factorUnitName;
          stockIssueItem.productUnits = item.productUnits;
          stockIssueItem.qcNo = "";
          stockIssueItem.qty = item.qty;
          stockIssueItem.remark = "";
          stockIssueItem.binId = "";
          this.stockIssueDetailList.push(stockIssueItem);
        });
        this.dialogClose({
          issueNo: emr.issueNo,
          isWholeSaleIssueNo: false,
          stockIssueDetailList: this.stockIssueDetailList,
        });
      } else {
        this.dialogClose({});
      }
    },
    dialogClose(obj) {
      this.$emit("close", obj);
    },
  },
};
</script>
  